import fetchMock from 'fetch-mock';
import { useLayoutEffect } from 'react';
/**
 * Based on the implementation of @react-mock/fetch.
 * @see https://github.com/skidding/react-mock/tree/master/packages/fetch
 *
 * The implementation has been copied here because @react-mock/fetch seems to have been abandoned,
 * and it is using outdated dependencies which conflict with ours.
 *
 */
export const Wrapper = ({ children, config, matcher, mocks, options, response, }) => {
    useLayoutEffect(() => {
        // Clear mocks from a previous FetchMock instance
        // NOTE: The last rendered FetchProxy instance will override mocks from
        // the previous ones
        fetchMock.restore?.();
        if (config) {
            Object.assign(fetchMock.config, config);
        }
        if (mocks) {
            mocks.forEach((item) => {
                fetchMock.mock(item);
            });
        }
        else if (matcher && response) {
            fetchMock.mock(matcher, response, options);
        }
        else if (options) {
            fetchMock.mock(options);
        }
        return () => {
            fetchMock.restore?.();
        };
    });
    return children;
};
/**
 * @deprecated Use `FetchMock.Wrapper` instead
 */
export const FetchMock = Wrapper;
